// extracted by mini-css-extract-plugin
export default {"content":"uny3WuZkNyyTpRcbH9_w","text":"bLkef3I4BQwC0uMvnop8"};